export const ProgressionSteps = {
    TermsOfUse20230101: "TermsOfUse20230101"
}
